import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    EventExtra1: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'DISCOVER NORTHERN VIRGINIA\'S BEST EVENT VENUE',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
      },
      {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:*',
           mapping: 'lastName'
         }
       ]
      },
       {
         fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
          {
             type: 'text',
             size: 'Medium',
             label: 'Phone:*',
             mapping: 'telnumber'
            }
          ]
         },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Preferred Date:*',
              mapping: 'eventDate'
            },
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Alternative Date:*',
              mapping: 'EventExtra1'
          }
      ]
      },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Number of Guests:*',
                mapping: 'plannedguestcount'
              },
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Services Interested In:*',
                options: [
                  { label: 'Wedding', value: 'Wedding' },
                  { label: 'Wedding related event (rehearsal dinner, engagement party, etc.)', value: 'Wedding related event (rehearsal dinner, engagement party, etc.)' },
                  { label: 'Bar/ Bat Mitzvah', value: 'Bar/ Bat Mitzvah' },
                  { label: 'Gala & Fundraiser', value: 'Gala & Fundraiser' },
                  { label: 'Quinceañera', value: 'Quinceañera' },
                  { label: 'Reunion', value: 'Reunion' },
                  { label: 'Corporate Celebration', value: 'Corporate Celebration' },
                  { label: 'Association Celebration', value: 'Association Celebration' },
                  { label: 'Corporate Meeting', value: 'Corporate Meeting' },
                  { label: 'Association Meeting', value: 'Association Meeting' },
                  { label: 'Other', value: 'Other' },
                ],
                mapping: 'theme'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'XLarge',
                label: 'Please tell us any other details regarding your event you\'d like us to know:',
                mapping: 'notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Crystal View Events and Conference Center Contact Form',
    formId: '1917',
    clientKey: 'CF5A1F76-818C-4C9E-B3C8-75EC83572807',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.crystalview.com/thank-you',
    submissionText: 'Thank you for your inquiry. We will reach out shortly.  Please note that messages received after 5:00pm Friday "may" not receive a response until Monday morning.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
